import { render, staticRenderFns } from "./ModalAdicionarDocumentosGenerico.vue?vue&type=template&id=0361a200&scoped=true"
import script from "./ModalAdicionarDocumentosGenerico.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarDocumentosGenerico.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarDocumentosGenerico.vue?vue&type=style&index=0&id=0361a200&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361a200",
  null
  
)

export default component.exports